import { ENDPOINT } from 'api/endPoints/getAsigneList';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import {
    EXTRA_LARGE,
    LARGE,
    LARGE_SHORT,
    MEDIUM,
    MEDIUM_SHORT,
    SMALL,
    SMALL_LONG,
} from 'components/Dashboards/Reporting/reportingConfig';

export const customReportText: IHashmapItemComponentProps = {
    NoPermissionMessage,
    reportConfig: {
        buttons: {
            narrative: false,
        },
    },
    title: 'Free Text',
    id: 'CustomReportTextId',
    componentKey: 'customReportText',

    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            smallLong: SMALL_LONG,
            mediumShort: MEDIUM_SHORT,
            medium: MEDIUM,
            largeShort: LARGE_SHORT,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
            custom: 'custom',
        },
        widgetInitialSize: MEDIUM_SHORT,
        isResizable: true,
        minHeight: 1,
        minWidth: SMALL.w,
        maxHeight: EXTRA_LARGE.h,
        maxWidth: EXTRA_LARGE.w,
    },
    endpoint: ENDPOINT,
};
